import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { UsageLimitService } from '../../services/usage-limit/usage-limit.service';

/** Plano Minimum não acessa a rota; volta para o painel. */
export const minimumPlanBlockedGuard: CanActivateFn = () => {
    const usageLimitService = inject(UsageLimitService);
    const router = inject(Router);

    return usageLimitService
        .ensureUsageLoaded()
        .pipe(map(() => (usageLimitService.isMinimumPlan() ? router.parseUrl('/v2/painel') : true)));
};
